import React from "react";

const EventPill = ({ event, styles, screenSize, language, t, onEventClick }) => {
  // The start time only earns its place when the cell is wide enough that the
  // title still reads: either the calendar spans the full page (no sidebar
  // beside it, below 1200px) or the screen is genuinely large. Otherwise the
  // time would eat the row and leave "اجتم…" behind. It stays available in the
  // tooltip, the day popup and the event modal.
  const roomyCell = screenSize.width < 1200 || screenSize.width >= 1500;
  const showTime = !!event.time && !screenSize.isMobile && roomyCell;

  return (
    <button
      type="button"
      className="event-pill"
      style={styles.eventItem(event)}
      onClick={(e) => {
        e.stopPropagation();
        onEventClick(event);
      }}
      aria-label={`${t.viewEvent} ${event.title}`}
      aria-haspopup="dialog"
      title={`${event.time ? `${event.time} — ` : ""}${event.title}`}
    >
      {showTime && <span style={styles.eventItemTime}>{event.time}</span>}
      <span
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          flex: "1 1 auto",
          minWidth: "28px",
        }}
      >
        {event.title}
      </span>
    </button>
  );
};

export default EventPill;
